<ol class="breadcrumb">
  <li style="cursor: pointer;" (click)="getRoute('/')" ><a  class="text-lg"><span class="icon-home"></span></a></li>
  <li style="cursor: pointer;" (click)="getRoute(routes[1])" [ngClass]="{ active: !routes[1] }" ><a > {{  !routes[1] ?  nameUrl  : routes[1] | titlecase}} </a></li>
  <li style="cursor: pointer;" (click)="getRoute(routes[2])" ><a >{{routes[2] | titlecase}}</a></li>
  <li style="cursor: pointer;" [ngClass]="{active: routes[3]}" ><a  >{{routes[3] | titlecase}}</a></li>
</ol>
